import LinkInfo from '@/components/LinkInfo/LinkInfo';
import styles from './LinkedBundle.module.css';

export const LinkedBundle = () => (
  <div className={styles.headerLinkedBundle}>
    <div>
      <LinkInfo />
    </div>
    <div className={styles.headerLinkedBundleLabel}>Linked bundle - Changes will affect all linked bundles.</div>
  </div>
);
